if(document.querySelector('.ct-features')) {

//set menu array to data-tab-titles value of .ct-features. clean up trailing comma and any spaces
var menu = document.querySelector('.ct-features').dataset.tabTitles.replace(/,\s*$/, "").split(',');

var featuresSlider = new Swiper(".ct-features-swiper", {
  slidesPerView: 1,
  effect: "fade",
  pagination: {
    el: ".ct-features .pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<div class="ct-features__tab-title ' + className + '">' + menu[index] + "</div>";
    },
  },
});


featuresSlider.on("slideChange", () => {
  console.log('featuresSlider activeIndex: ' + featuresSlider.activeIndex);
  //hide all .ct-features__copy elements that do not have a matching data-slide attribute
  var activeSlides = document.querySelectorAll(`.ct-features__copy[data-slide="${featuresSlider.activeIndex}"]`);
  var slides = document.querySelectorAll('.ct-features__copy');
  slides.forEach((slide) => {
    slide.classList.remove('ct-features__copy--active');
  });
  activeSlides.forEach((slide) => {
    slide.classList.add('ct-features__copy--active');
  });  

});



document.addEventListener('DOMContentLoaded', function() {
  // Get all accordion toggles
  const accordionToggles = document.querySelectorAll('.ct-features__drawer-header');

  accordionToggles.forEach(toggle => {
    if (!toggle.hasAttribute('data-listener-attached')) {
      toggle.addEventListener('click', function() {
        const featureDescriptionWrapper = this.closest('.ct-features__drawer').querySelector('.ct-features__feature-description-wrapper');
        
        // Toggle display and maximum height
        if (featureDescriptionWrapper.classList.contains('active')) {
          featureDescriptionWrapper.style.maxHeight = '0';
        } else {
          featureDescriptionWrapper.style.maxHeight = featureDescriptionWrapper.scrollHeight + 'px';
        }

        featureDescriptionWrapper.classList.toggle('active');
        
        // Toggle button text and add rotation
        if (!this.classList.contains('rotated')) {
          this.classList.add('rotated');
        } else {
          this.classList.remove('rotated');
        }
      });

      // Mark that the element has an event listener
      toggle.setAttribute('data-listener-attached', 'true');
    }
  });
});

}